import React from 'react';

export const Ed12 = (): React.ReactElement => {
  const style = {
    img: 'border-gray-300 border-r border-b border-l'
  };
  return (
    <div className="event-contents">
      <div className="event-detail">
        <div className="md:-mx-16 sm:-mx-16">
          <img className={style.img} src="../images/Top/event/event_0012_mv.jpg" width="978" height="504" alt="" />
        </div>
        <h1 className="mt-56 sm:mt-30 text-29_46 sm:text-18_24 font-bold text-center">12/22（木）19:30 -<br />
          自己PRと<br className="md:hidden lg:hidden" />ポートフォリオ作成について</h1>
        <section className="mt-30 sm:mt-24 mb-40 sm:mb-18">
          <div className="flex flex-col items-center justify-center px-16 py-25 sm:p-16 bg-gray-100">
            <p className="mb-10 lg:mb-16 text-18_33 sm:text-14_21 font-bold">このセミナーの受付は終了しています。</p>
            <p className="text-16_28 sm:text-14_21">定期的にセミナーを開催しておりますので、<br className="sm:hidden" />最新の開催情報は<a className="textLink" href="../event/">こちら</a>よりご確認ください。</p>
          </div>
        </section>
        <section>
          <h2 className="text-24_24 sm:text-15_22 font-bold mt-80 sm:mt-55 mb-40 sm:mb-18 sm:pb-6">以下に該当する方はオススメです。</h2>
          <div className="mt-30 sm:mt-16 p-40 sm:p-24 box-line text-left">
            <ul className="text-16_28 sm:text-14_21">
              <li className="flex mb-4">
                <span><i className="mbx-naviInpage-item-icon mbx-icon mbx-icon-Done"></i></span><span>転職を実際に考えている、もしくは、今後のキャリア形成について悩んでいる人</span>
              </li>
              <li className="flex mb-4">
                <span><i className="mbx-naviInpage-item-icon mbx-icon mbx-icon-Done"></i></span><span>事業会社／クライアントワークのどちらにしようか悩んでいる人</span>
              </li>
              <li className="flex mb-4">
                <span><i className="mbx-naviInpage-item-icon mbx-icon mbx-icon-Done"></i></span><span>Webデザイナーとして今後も活躍できるキャリアを選びたいが、どう考えて良いかわからない人</span>
              </li>
              <li className="flex mb-4">
                <span><i className="mbx-naviInpage-item-icon mbx-icon mbx-icon-Done"></i></span><span>Web業界での転職に向けて、しっかりとした準備を整えたい</span>
              </li>
              <li className="flex mb-4">
                <span><i className="mbx-naviInpage-item-icon mbx-icon mbx-icon-Done"></i></span><span>企業分析の考え方とまとめ方を知りたい</span>
              </li>
              <li className="flex mb-4">
                <span><i className="mbx-naviInpage-item-icon mbx-icon mbx-icon-Done"></i></span><span>業界のちょっとした裏話を聞いてみたい</span>
              </li>
              <li className="flex mb-4">
                <span><i className="mbx-naviInpage-item-icon mbx-icon mbx-icon-Done"></i></span><span>自身の今後のキャリアの方向性を定めたい</span>
              </li>
              <li className="flex">
                <span><i className="mbx-naviInpage-item-icon mbx-icon mbx-icon-Done"></i></span><span>セミナーを踏まえて転職の相談をしたい</span>
              </li>
            </ul>
          </div>
        </section>
        <section className="mt-80 sm:mt-55">
          <h3 className="text-18_24 sm:text-14_21 font-bold">イベント内容</h3>
          <div className="mt-30 sm:mt-16 mb-30">
            <img src="../images/Top/event/event_0012_image.jpg" width="980" height="374" alt="" />
          </div>
          <p className="text-16_28 sm:text-14_21 mt-30">
            デザイナーが転職活動を行ううえで必要不可欠なポートフォリオ。しかし、「何から始めたら良いのかわからず、制作がなかなか進まない」「多忙な日々の仕事に追われながら、ポートフォリオを作成するのは大変」など、デザイナーにとってポートフォリオの作成が高いハードルとなっているようです。また、転職活動は選考企業・採用担当者にご自身のキャリアを適切にアピールをしなければならないのですが、こちらもどんな情報をどのようにまとめればよいのかわからない、というお声もよくいただきます。<br />
            <br />
            そこで、デザイナーとしてキャリアのアピールポイントをどのように整理し、それぞれ履歴書・職務経歴書・ポートフォリオにどのようにまとめるのが良いのか木村よねこ氏を講師に迎えてお話をいただきます。<br />
            木村氏はWebデザイナーとして15年目を迎え、多数の企業でWebデザイナー＆クリエイティブディレクターとして活動し、現在、事業会社にジョインしデザインの内製化対応や自社サービスのデザインを行うなど自身のキャリアをステップアップさせてきました。<br />
            セミナーでは、各書類準備をMATCHBOXを使って、時間をかけずきちんとポイントをおさえて作成し、企業に伝える方法をお話します。<br />
            オンラインで開催となりますので、興味がある方はお早めにご応募ください。
          </p>
        </section>
        <section className="mt-80 sm:mt-55">
          <h3 className="text-18_24 sm:text-14_21 font-bold">参加者の声</h3>
          <div className="mt-30 mb-15 sm:mt-16 sm:mb-8 p-40 sm:p-24 box-line text-left">
            <ul className="text-16_28 sm:text-14_21">
              <li className="flex mb-4">
                <span>・</span><span>実際に活躍されている方の話を聞いて、業界に対する解像度、キャリア形成の仕方の見通しがついた。<br />（25歳 制作会社 グラフィックデザイナー 3年目）</span>
              </li>
              <li className="flex mb-4">
                <span>・</span><span>キャリアの戦略や自己分析のしかた情報収集の仕方がよく分かった。<br />（26歳 Webデザイナー 4年目）</span>
              </li>
              <li className="flex">
                <span>・</span><span>個人でデザイナーの将来像を考えたときは、専門性が高くなることに乗じて選択肢が狭まるような認識があったが、お話を聴き、将来像をより広く考えられるきっかけになった。<br />（30歳 制作会社 Webデザイナー 8年目）</span>
              </li>
            </ul>
          </div>
          <p className="text-right text-16_28 sm:text-14_21">※参加者の声の一部を掲載しています</p>
        </section>
        <section>
          <h2 className="text-24_24 sm:text-15_22 font-bold mt-80 sm:mt-55 mb-40 sm:mb-18 sm:pb-6">講師プロフィール</h2>
          <div className="event-instructor box-line sm:p-16">
            <div className="instructor-photo">
              <img src="../images/Top/event/event_0006_prof.jpg" alt="" />
            </div>
            <dl className="instructor-prof sm:mt-16">
              <dt className="instructor-name text-16_28 font-bold">
                木村 よねこ<span className="inline-block">（YONECO KIMURA）</span>
              </dt>
              <dd className="instructor-position text-16_28 sm:text-14_21 mb-40 sm:mb-18">
                デザイナー兼ディレクター<br />一般社団法人 日本ディレクション協会 所属
              </dd>
              <dd className="instructor-career text-16_28 sm:text-14_21">
                茨城県出身。筑波研究学園専門学校グラフィックデザイン学科卒業後、外食産業の制作デザイナーとして就職。自社運営店舗のメニュー・ポスター、広報誌など広報販促物の制作・デザインを行う。2007年にWebデザイナーを目指して上京。多数の企業でWebデザイナー＆クリエイティブディレクターとして活動しWeb制作・Webコンサルティング支援に従事。2010年よりGMOTECH株式会社にてSEO事業部のコーダー兼Webデザイナー、広告事業部のディレクターを経験。2015年にAIS株式会社立ち上げメンバーとして参画し新規サービス・メディアのサイト制作、ディレクションを行う。2022年からは株式会社Buzzreachで初のデザイナーとしてジョイン。デザインの内製化対応や自社サービスのデザインを行う。
              </dd>
            </dl>
          </div>
        </section>
        <section>
          <h2 className="text-24_24 sm:text-15_22 font-bold mt-80 sm:mt-55 mb-40 sm:mb-18 sm:pb-6">当日スケジュール</h2>
          <table className="index timetable text-16_28 sm:text-14_21 mb-30 sm:mb-12">
            <tbody>
              <tr>
                <th scope="row" className="bg-gray-50 font-normal whitespace-nowrap" rowSpan={2}>
                  <span className="sm:block">19：30</span><span className="sm:block">～</span><span className="sm:block">21：00</span>
                </th>
                <td>
                  ＜前半＞ アピールポイントの整理と面接について
                  <ul className="text-16_28 sm:text-14_21">
                    <li className="flex"><span>・</span><span>アピールポイントの整理</span></li>
                    <li className="flex"><span>・</span><span>選考書類の準備について</span></li>
                    <li className="flex"><span>・</span><span>面接対策について</span></li>
                    <li className="flex"><span>・</span><span>未経験者と経験者に求めている事の違い</span></li>
                  </ul>
                </td>
              </tr>
              <tr>
                <td>
                  ＜後半＞ ポートフォリオ作成と事例について
                  <ul className="text-16_28 sm:text-14_21">
                    <li className="flex"><span>・</span><span>ポートフォリオの考え方</span></li>
                    <li className="flex"><span>・</span><span>実績の作り方</span></li>
                    <li className="flex"><span>・</span><span>ポートフォリオの作り方と事例</span></li>
                    <li className="flex"><span>・</span><span>さいごに</span></li>
                    <li className="flex"><span>・</span><span>質疑応答</span></li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <section className="mb-64 sm:mb-48">
          <h2 className="text-24_24 sm:text-15_22 font-bold mt-80 sm:mt-55 sm:mb-8 sm:pb-6 text-left">開催概要</h2>
          <table className="summary text-16_28 sm:text-14_21">
            <tbody>
              <tr>
                <th scope="row" className="font-normal text-left">開催日時</th>
                <td>2022/12/22（木）19:30～<br />
                  [入室開始] 19:00～</td>
              </tr>
              <tr>
                <th scope="row" className="font-normal text-left">開催方法</th>
                <td>Zoom開催<br />参加者の皆さまには別途URLをお送りします。</td>
              </tr>
              <tr>
                <th scope="row" className="font-normal text-left">参加費</th>
                <td>無料</td>
              </tr>
              <tr>
                <th scope="row" className="font-normal text-left">対象者</th>
                <td>転職を実際に考えている、もしくは、今後のキャリア形成について考えている事業会社／制作会社のWebデザイナー</td>
              </tr>
              <tr>
                <th scope="row" className="font-normal text-left">応募手順</th>
                <td>
                  <dl>
                    <dt className="mb-18 sm:mb-8">1.参加申し込み</dt>
                    <dd className="mb-38 sm:mb-16">MATCHBOXへログインいただき、お申し込みください。（アカウント作成は<a className="textLink"
                      href="https://matchbox.work/entry">こちら</a>から）</dd>
                    <dt className="mb-18 sm:mb-8">2.ご連絡</dt>
                    <dd className="mb-38 sm:mb-16">マッチボックス セミナー事務局より、MATCHBOXに登録していただいているメールアドレス宛に当日の詳細のご連絡差し上げます。</dd>
                    <dt className="mb-18 sm:mb-8">3.開催当日</dt>
                    <dd>当日はZoomにて開催いたします。</dd>
                  </dl>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <section className="mt-80 sm:mt-55">
          <h3 className="text-18_24 sm:text-14_21 font-bold">開催について</h3>
          <p className="text-16_28 sm:text-14_21 mt-30 sm:mt-16">
            Web・IT業界で必要不可欠な存在であるWebディレクター・Webデザイナーの皆さまを支援するために、日本ディレクション協会で受講者累計2,000名を超える「0からのWebディレクション講座」を生み出したメンバーでもあるSPEC.代表の助田正樹氏と連携して、Webの現場最前線で働くロールモデルの方々をゲストとしてお呼びし、キャリアを考えるために有益な情報提供を開始しています。          </p>
        </section>
        <div className='back_event-list flex flex-col items-center justify-center mt-120 sm:mt-55'>
          <div className="base-button isTextLink">
            <a className="button size-s theme-link flex items-center" href="./"><i className="mbx-icon mbx-icon-Arrow_Left mr-2"></i><span className="font-bold label">イベント一覧へ</span></a>
          </div>
        </div>
      </div>
    </div>
  );
};
